import styled from 'styled-components';

export const MainInfoBox = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 15px 0 0;
  display: grid;
  gap: 10px;
`;
